module.exports = __webpack_public_path__ + "static/IMG_7661-a59570575d9c678cf3eb2dd727db3e61.jpg";